<template lang="pug">
    .closer
</template>

<script>
    export default {
        name: "Closer"
    }
</script>

<style scoped lang="scss">
.closer{
    position: relative;
    width: 5rem;
    height: 5rem;
    cursor: pointer;
    &:before, &:after{
        content: '';
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        width: 100%;
        height: 3px;
        background: #000;
    }
    &:before{
        transform: translate(-50%, -50%) rotate(45deg);
    }
    &:after{
        transform: translate(-50%, -50%) rotate(-45deg);
    }
    @include mobile_or_P{
        &:before, &:after{
            height: 2px;
        }
    }
}
</style>
